export default "__VITE_ASSET__BLDG1Sl0__"